import(/* webpackMode: "eager" */ "/cg-test-project/app/global-error.tsx")